import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { ButtonModule } from "primeng/button";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

/** Which message pair the prompt shows. */
export type LoginPromptContext = "cart" | "generic";

@Component({
  selector: "app-login-prompt-dialog",
  imports: [TranslateModule, ButtonModule],
  templateUrl: "./login-prompt-dialog.component.html",
  styleUrl: "./login-prompt-dialog.component.css",
})
export class LoginPromptDialogComponent {
  private readonly dialogRef = inject(DynamicDialogRef);
  private readonly config = inject(DynamicDialogConfig);
  private readonly router = inject(Router);

  /** Selected from the opener's data; defaults to the generic shopping copy. */
  readonly context: LoginPromptContext = this.config.data?.context === "cart" ? "cart" : "generic";

  goToRegistration(): void {
    this.router.navigate(["/registration"]);
    this.dialogRef.close();
  }

  goToLogin(): void {
    this.router.navigate(["/login"]);
    this.dialogRef.close();
  }
}
